<template>

  <div class="custom-row">
    <div class="custom-col custom-col--100 custom-col--md-100">

      <div class="mb-3 fsz14"
           v-bind:class="{'red-color-style': isWarehouse}">
        <div class="mb-2"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['fbm_userChoose', 'cuspayments_SKLADUSAFeeAdd', 'fbm_giftBag', 'fbm_GiftMessage'])"></div>
          {{$t('fbm_userChoose.localization_value.value')}}
        </div>
        {{getUserChooseLabel}}
      </div>

      <div class="order-create__toggle-block toggle-block small-size">
        <div class="toggle-block__type min-w-140">
          <div class="toggle-block__type-list">
            <div class="d-flex align-items-center mb-3">
              <RadioDefault
                      class="wfc"
                      :label="'None'"
                      name="fedexRadioList2"
                      :value="FBM.data.packagingAdminType === ''"
                      @input="changePackageType(false)"
              />
            </div>

            <div class="d-flex align-items-center mb-3"
                 v-for="(item, index) in getPackagingTypes"
                 :key="index"
                 v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editPopup(item)"></div>
              <RadioDefault
                      class="wfc"
                      :label="item.currentTranslate.name"
                      name="fedexRadioList2"
                      :value="checkActivePackagingType(item)"
                      @input="changePackageType(item)"
              />

              <TooltipTextHelperPlugin>
                <template slot="text">
                  <TooltipBtn/>
                </template>
                <template slot="paragraph">
                  <div class="status-tooltip">
                    <div class="box-tooltip__img">
<!--                           v-if="!Array.isArray(item.file_entity) && Object.keys(item.file_entity).length" :src="`data:${item.file_entity.mime_type};base64,${item.file_entity.fileContentBase64}`"-->
                      <img style="max-width: 56px"
                           v-if="item.file_entity && Object.keys(item.file_entity).length && item.file_entity['file_url']" :src="item.file_entity['file_url']"
                           alt="img">
                      <img v-else src="/img/common/box-img.png" alt="img">
                    </div>
                  </div>
                </template>
              </TooltipTextHelperPlugin>
            </div>
          </div>
        </div>

        <template v-for="(item, index) in getPackagingTypes">

          <div class="toggle-block__details"
               id="packing-prices-block"
               :key="index"
               v-if="checkActivePackagingType(item)"
          >
            <div class="toggle-block__details-head">
              <div class="toggle-block__details-title">
                <span>Packaging Prices</span>
              </div>
            </div>

            <div class="toggle-block__details-body">
              <div class="custom-row">
                <div class="custom-col flex-column-reverse mb-2"
                     :key="getPackingPrice"
                >
                  <template
                          v-for="(itemPackingPrices, index) in getVisiblePackingPrices(item)"
                  >
                    <RadioDefault
                            :key="index"
                            class="mb-2 radio-center"
                            :label="itemPackingPrices.currentTranslate.name"
                            name="fedexRadioList23423"
                            :value="checkActivePackagingAdminPrice(itemPackingPrices)"
                            @input="changePackagingAdminPrice(item, itemPackingPrices)"
                    >
                      <template slot="card">
                        &nbsp;<b>${{itemPackingPrices.price}}</b>

                        <div class="block-table__ico status-ico" v-if="FBM.data.packagingAdminPriceRecommended && itemPackingPrices.id === FBM.data.packagingAdminPriceRecommended.id">
                          <img src="/img/common/check.svg" alt="ico">
                        </div>
                      </template>
                    </RadioDefault>
                  </template>

                  <div v-if="hasHiddenPackingPrices(item)" @click="showAllPackingPrices = true">
                    <ShowMore/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>
    </div>

    <div class="custom-col custom-col--md-100"
         v-if="!isNoAdditionalPackagingAdmin"
         v-bind:class="isWarehouse ? 'custom-col--66' : 'custom-col--25'">
      <div class="mb-3 fsz14 mobile-hide" v-if="!isWarehouse">
        <div class="mb-2">
          <br/>
        </div>
        <br/>
      </div>
      <template v-if="isWarehouse">
        <div class="order-create__section-label section-label"
             v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['fbm_giftPackaging'])"></div>
          {{$t('fbm_giftPackaging.localization_value.value')}}
        </div>

        <div class="order-create__row custom-row">
          <div class="order-create__col custom-col custom-col--sm-50 custom-col--wfc d-flex"
               v-if="giftPackTypePrices.length > 0"
               v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editPopup(giftPackTypePrices[0])"></div>
            <DefaultCheckbox
                class="wfc"
                :label="`${giftPackTypePrices[0].currentTranslate.name} (+$${giftPackTypePrices[0].price})`"
                :value="checkActiveGiftPackagingAdminPrice(giftPackTypePrices[0])"
                @input="(val) => val ? changeGiftPackagingAdminPrice(giftPackTypePrices[0], giftPackType) : changeGiftPackagingAdminPrice(false, null)"
            />

            <v-popover
                class="site-tooltip site-tooltip--radio-after"
                offset="5"
                placement="top-left"
                trigger="hover"
            >

              <TooltipBtn/>

              <template slot="popover">
                <div class="box-tooltip">
                  <div class="box-tooltip__img">
                    <img style="max-width: 56px"
                         v-if="giftPackType.file_entity && Object.keys(giftPackType.file_entity).length && giftPackType.file_entity['file_url']" :src="giftPackType.file_entity['file_url']"
                         alt="img">
                    <img v-else src="/img/common/box-img.png" alt="img">
                  </div>
                  <div class="box-tooltip__content">
                    <p>
                      <b>{{giftPackTypePrices[0].currentTranslate.name}}</b>
                    </p>
                    <p>
                      {{giftPackTypePrices[0].currentTranslate.description}}
                    </p>
                  </div>
                </div>
              </template>
            </v-popover>
          </div>
        </div>
      </template>

<!--      <div class="order-create__toggle-block toggle-block small-size" v-if="isWarehouse">-->
<!--        <div class="toggle-block__details">-->
<!--          <div class="toggle-block__details-head">-->
<!--            <div class="toggle-block__details-title"-->
<!--                 v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">-->
<!--              <div class="admin-edit" @click="editTranslate(['fbm_giftBag'])"></div>-->
<!--              <span>{{$t('fbm_giftBag.localization_value.value')}}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="toggle-block__type min-w-140">-->
<!--            <div class="toggle-block__type-list">-->
<!--              <div class="w-100"-->
<!--                   v-if="giftPackTypePrices.length > 0"-->
<!--                   v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">-->
<!--                <div class="admin-edit" @click="editPopup(giftPackTypePrices[0])"></div>-->
<!--                <DefaultCheckbox-->
<!--                    class="mb-2"-->
<!--                    :label="giftPackTypePrices[0].currentTranslate.name + ' & price: ' + giftPackTypePrices[0].price"-->
<!--                    :value="checkActiveGiftPackagingAdminPrice(giftPackTypePrices[0])"-->
<!--                    @input="(val) => val ? changeGiftPackagingAdminPrice(giftPackTypePrices[0], giftPackType) : changeGiftPackagingAdminPrice(false, null)"-->
<!--                />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="order-create__toggle-block toggle-block small-size" v-if="!isWarehouse">
        <div class="toggle-block__details">
          <div class="toggle-block__details-head">
            <div class="toggle-block__details-title"
                 v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['fbm_giftBag'])"></div>
              <span>{{$t('fbm_giftBag.localization_value.value')}}</span>
            </div>
          </div>
          <div class="toggle-block__type min-w-140">
            <div class="toggle-block__type-list">
              <div class="d-flex align-items-center mb-2">
                <RadioDefault
                    class="wfc"
                    :label="'None'"
                    name="giftPackPriceRadio"
                    :value="FBM.data.giftPackagingAdminType === '' || FBM.data.giftPackagingAdminType === null"
                    @input="changeGiftPackagingAdminPrice(false, null)"
                />
              </div>

              <div
                  v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
                <template
                    v-for="(priceItem, index) in giftPackTypePrices"
                >
                  <div :key="index">
                    <div class="admin-edit" @click="editPopup(priceItem)"></div>
                    <RadioDefault

                        class="mb-2"
                        :label="priceItem.currentTranslate.name + ' & price: ' + priceItem.price"
                        name="giftPackPriceRadio"
                        :value="checkActiveGiftPackagingAdminPrice(priceItem)"
                        @input="changeGiftPackagingAdminPrice(priceItem, giftPackType)"
                    />
                  </div>


                </template>

              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

    <PackingTypeEditPopup
            v-if="isActiveEditPopup"
            :item="itemEdit"
            @close="closeEditPopup"
    />

  </div>
</template>

<script>
  import RadioDefault from "../../../../../../UI/radiobuttons/RadioDefault/RadioDefault";
  import TooltipBtn from "../../../../../../UI/tooltips/TooltipBtn/TooltipBtn";
  import PackingTypeEditPopup from "../../../../../../coreComponents/Popups/PackingTypeEditPopup/PackingTypeEditPopup";
  import TooltipTextHelperPlugin from "@/components/coreComponents/TooltipTextHelperPlugin/TooltipTextHelperPlugin";
  import ShowMore from "@/components/coreComponents/Buttons/ShowMore/ShowMore";
  import {FBMGiftPackagingMixin, FBMMixins} from "@/mixins/FBMMixins/FBMMixins";
  import DefaultCheckbox from "@/components/UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
  import {FBM_PACKING_TYPE_CODES_ONLY_WAREHOUSE} from "@/staticData/staticVariables";

  export default {
    name: "AdminPackingPrices",
    components: {
      TooltipTextHelperPlugin,
      PackingTypeEditPopup,
      ShowMore,
      TooltipBtn,
      RadioDefault,
      DefaultCheckbox,
    },

    mixins: [FBMMixins, FBMGiftPackagingMixin],

    props: {
      FBM: Object,
    },

    computed: {
      activeUserType() {
        let name = this.FBM.data.packagingType?.translationStorage?.en?.name
        if(!this.isWarehouse || !name || !this.getUserPackingPrice) return name

        return `${name}, ${this.getPackingPriceLabel(this.getUserPackingPrice)}`
      },

      getUserChooseLabel() {
        let add = this.$t('cuspayments_SKLADUSAFeeAdd.localization_value.value')
        let labels = [this.activeUserType]
        if(this.userGiftBag) labels.push(`${add} ${this.$t('fbm_giftBag.localization_value.value')}`)
        if(this.userGiftMessage) labels.push(`${add} ${this.$t('fbm_GiftMessage.localization_value.value')}`)
        return labels.filter(item => item).join('; ')
      },

      // ціна юзера (або дефолтна ціна його типу) — відповідник серед цін адмінських типів
      getUserPackingPrice() {
        let id = this.FBM.data.packagingTypePrice?.id || this.FBM.data.packagingType?.user_packing_price?.id
        if(!id) return null

        let prices = this._.flatMap(this.FBM.data.packagingTypes, type => type.packing_prices || [])
        return this._.find(prices, {id}) || null
      },

      getPackingPrice(){
        return this.FBM.data.packagingAdminPrice?.id
      },

      getPackagingTypes() {
        if(this.isWarehouse) return this.FBM.data.packagingTypes
        return this._.filter(this.FBM.data.packagingTypes, item => !FBM_PACKING_TYPE_CODES_ONLY_WAREHOUSE.includes(item.code))
      },
    },

    watch: {
      'FBM.data.packagingAdminPriceRecommended'() {
        this.showAllPackingPrices = false
      }
    },

    data() {
      return {
        packageTypes: [],
        giftPackType: null,
        giftPackTypePrices: [],
        isActiveEditPopup: false,
        itemEdit: {},
        showAllPackingPrices: false,
        userGiftBag: false,
        userGiftMessage: false,
      }
    },

    mounted() {

      this.packageTypes = this.FBM.data.packagingTypes
      // gift із замовлення на момент відкриття — для "User choose"
      this.userGiftBag = !!this.FBM.data.giftPackagingAdminPrice?.id
      this.userGiftMessage = !!this.FBM.data.giftPaper?.id
      if(this.isWarehouse && !this.FBM.data.packagingAdminPrice && this.getUserPackingPrice) {
        this.FBM.setPackagingAdminPrice(this.getUserPackingPrice)
      }
      if(this.isWarehouse && !this.FBM.data.packagingAdminType) {
        this.setUserPackagingAdminType()
      }
      this.giftPackType = this.FBM.data.giftPackagingTypes.length > 0 ? this.FBM.data.giftPackagingTypes[0] : null
      if (this.giftPackType) {
        this.giftPackTypePrices = this.giftPackType?.packing_prices || []
      }
      // console.log(this.giftPackType);

      // let packingPrice = this.FBM.getPackagingAdminPrice()

      // if(!packingPrice){
      //   let firstType = this._.first(this.packageTypes)
      //   let firstPrice = this._.first(firstType['packing_prices'])
      //   this.FBM.setPackagingAdminPrice(firstPrice)
      // }

      // this.$store.dispatch('getDeliveryPackingTypeForAdmin').then(response => {
      //   this.packageTypes = this.getRespPaginateData(response)
      // })

    },

    methods: {

      getSortPrices(prices) {
        if (!Array.isArray(prices)) {
          return []
        }

        let selectedId = this.FBM.data.packagingAdminPrice?.id

        return [...prices]
          // .filter(item => item.currentTranslate?.name?.trim().charAt(0) === '#')
          // неактивні ховати, крім вибраної
          .filter(item => item.is_active || item.id === selectedId)
          .sort((a, b) => {
            return Number(a.price) - Number(b.price)
          })
      },

      getVisiblePackingPrices(item) {
        let sorted = this.getSortPrices(item.packing_prices)

        if (this.showAllPackingPrices) {
          return sorted
        }

        let recommendedId = this.FBM.data.packagingAdminPriceRecommended?.id
        if (!recommendedId) {
          return sorted
        }

        let index = sorted.findIndex(price => price.id === recommendedId)
        if (index === -1) {
          return sorted
        }

        let start = Math.max(0, index - 3)
        let end = Math.min(sorted.length, index + 4)

        return sorted.slice(start, end)
      },

      hasHiddenPackingPrices(item) {
        return this.getVisiblePackingPrices(item).length < this.getSortPrices(item.packing_prices).length
      },

      // адмінський тип за вибором юзера: тип його ціни, інакше тип з тим самим code
      setUserPackagingAdminType() {
        let priceTypeId = this.getUserPackingPrice?.packing_type_id
        let code = this.FBM.data.packagingType?.code
        let type = this._.find(this.FBM.data.packagingTypes, item => {
          return priceTypeId ? item.id === priceTypeId : item.code === code
        })

        if(type) this.FBM.setPackagingAdminType(type)
      },

      changePackageType(item) {
        if(!item){
          this.FBM.setPackagingAdminType('')
          this.FBM.setPackagingAdminPrice(null)
        }
        this.FBM.setPackagingAdminType(item)
        this.FBM.setPackagingAdminPrice(null)
        // this.FBM.setPackagingAdminPrice(this._.first(item['packing_prices']))
      },

      changePackagingAdminPrice(item, itemPackingPrices) {
        this.FBM.setPackagingAdminType(item)
        this.FBM.setPackagingAdminPrice(itemPackingPrices)

        // для warehouse підставити габарити ціни в lb/oz/inch, без них — очистити
        if(this.isWarehouse) {
          let dim = itemPackingPrices?.admin_dimension?.imperial
          this.FBM.data.AdminDimensions.data.weightLB = dim?.weight_lb ? Number(dim.weight_lb) : this.FBM.data.AdminDimensions.data.weightLB
          this.FBM.data.AdminDimensions.data.weightOZ = dim?.weight_oz ? Number(dim.weight_oz) : this.FBM.data.AdminDimensions.data.weightOZ
          this.FBM.data.AdminDimensions.data.height = dim ? Number(dim.height_inch).toFixed(2) : ''
          this.FBM.data.AdminDimensions.data.width = dim ? Number(dim.width_inch).toFixed(2) : ''
          this.FBM.data.AdminDimensions.data.dimensionLength = dim ? Number(dim.length_inch).toFixed(2) : ''
        }

        if(this.isConsolidation) {
          this.calculatePackingToImperial()
          if(itemPackingPrices?.admin_dimension?.imperial) {
            let dim = itemPackingPrices?.admin_dimension?.imperial
            // this.FBM.data.AdminDimensions.data.weightLB = dim?.weight_lb === 0 ? '' : Number(this.FBM.data.AdminDimensions.data.weightLB) + Number(dim?.weight_lb)
            // this.FBM.data.AdminDimensions.data.weightOZ = dim?.weight_oz === 0 ? '' : Number(this.FBM.data.AdminDimensions.data.weightOZ) + Number(dim?.weight_oz)
            // this.FBM.data.AdminDimensions.data.height = Number(Number(this.FBM.data.AdminDimensions.data.height) + Number(dim?.height_inch)).toFixed(2)
            // this.FBM.data.AdminDimensions.data.width = Number(Number(this.FBM.data.AdminDimensions.data.width) + Number(dim?.width_inch)).toFixed(2)
            // this.FBM.data.AdminDimensions.data.dimensionLength = Number(Number(this.FBM.data.AdminDimensions.data.dimensionLength) + Number(dim?.length_inch)).toFixed(2)
            this.FBM.data.AdminDimensions.data.weightLB = dim?.weight_lb === 0 ? '' : Number(dim?.weight_lb)
            this.FBM.data.AdminDimensions.data.weightOZ = dim?.weight_oz === 0 ? '' : Number(dim?.weight_oz)
            this.FBM.data.AdminDimensions.data.height = Number(dim?.height_inch).toFixed(2)
            this.FBM.data.AdminDimensions.data.width = Number(dim?.width_inch).toFixed(2)
            this.FBM.data.AdminDimensions.data.dimensionLength = Number(dim?.length_inch).toFixed(2)
          }
          this.getShippingPrices(true)
        }
      },

      checkActivePackagingAdminPrice(item) {
        return this.FBM.data.packagingAdminPrice?.id === item.id
      },

      changeGiftPackagingAdminPrice(itemPackingPrices, packType) {
        this.FBM.setGiftPackagingAdminPrice(itemPackingPrices)
        this.FBM.setGiftPackagingAdminType(packType)
      },

      checkActiveGiftPackagingAdminPrice(item) {
        // console.log(5555555555555, this.FBM.data.giftPackagingAdminPrice, item.id);
        return this.FBM.data.giftPackagingAdminPrice?.id === item.id
      },


      checkActivePackagingType(item) {
        return this.FBM.data.packagingAdminType?.id === item.id
      },

      editPopup(item){
        this.itemEdit = item
        this.isActiveEditPopup = true
      },

      closeEditPopup(){
        this.itemEdit = {}
        this.isActiveEditPopup = false
        this.$store.dispatch('getDeliveryPackingType')
      }
    },
  }
</script>

<style scoped>
.radio-center >>> .radio-default__label {
  display: flex;
  align-items: center;
}

.red-color-style {
  color: #ff0c0c;
}
</style>
